import { useEffect } from "react";
import { useIntl } from "react-intl";
import { addError } from "@wayflyer/blackbox-fe";

import { ErrorComponent } from "./error-component";
import { getCustomerErrorPresetMap } from "./error-presets";

export const UnknownRouteError = () => {
  const intl = useIntl();
  const { title, message, footerText, primaryAction } = getCustomerErrorPresetMap({ intl })["404"];

  useEffect(() => {
    addError("User landed on react router 404 wildcard route", {
      path: window.location.pathname,
      url: window.location.href,
    });
  }, []);

  return <ErrorComponent title={title} message={message} footerText={footerText} primaryAction={primaryAction} />;
};
